import { useHasMultipleStorePlatformsQuery } from "@shared/data/queries/HasMultipleStorePlatformsQuery/HasMultipleStorePlatforms.query";
import { useFlippers } from "@shared/hooks/useFlippers/useFlippers";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { useSonicSegmentProvidersExperiment } from "@shared/hooks/useSonicSegmentProviderExperiment/useSonicSegmentProviderExperiment";

const useSonicNPIImprovementsExperiment = () => {
  const [isSonicNPIImprovementsFlipper] = useFlippers("sonic_onboarding_npi_improvements");

  const isSonicSegmentProvidersEnabled = useSonicSegmentProvidersExperiment();
  const { isEmerson, isUnauthenticated } = useSharedGlobalConfig();
  const { data: officeData } = useHasMultipleStorePlatformsQuery({ skip: isUnauthenticated });
  const { hasMultipleStorePlatforms } = officeData?.currentOffice?.user ?? {};

  return (
    isSonicSegmentProvidersEnabled &&
    isSonicNPIImprovementsFlipper &&
    !isEmerson &&
    !hasMultipleStorePlatforms
  );
};

export { useSonicNPIImprovementsExperiment };
